

export class Model_CRM_Time {
    public TimeId: number;
    public TimeDesc: string;
}